<template>
  <div v-if="payload">
    <link-entity :payload="payload.company" :additional_data="additional_data"></link-entity>
    <p class="mt-3">{{ payload.position_title }}</p>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'

export default {
  name: 'CellCompanyPosition',
  components: {
    LinkEntity
  },
  props: ['payload', 'additional_data'],
}
</script>
<style scoped>
.mt-3 {
  margin-top: 0.75rem;
}
</style>
